// Third Party Library
import { useState, useEffect } from "react";
import { Dropdown, Tabs, message } from "antd";
import { useSelector, useDispatch } from "react-redux";

// Constants Library
import { TEMPLATE } from "../../../../constants";

// Components Library
import { TableList, ButtonLink, DrawerRemark } from "../../../../components";
import { ActionItems } from "./actions";
import { ExpandTableItems } from "./expandItem";
import {
  EditCompanyDrawer,
  ReviseCompanyThrshldDrawer,
} from "../DrawerCreateEditCompany";

// Handler Library
import { tableHDLR, filter } from "../../../../handlers";
import { handleRequestStatus } from "./functions"

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../services/util";

// Styles Library

const { COMPANY_SUMMARY_COL, EXPAND_COMPANY_SUMMARY_COL } = TEMPLATE.TABLEDATA.COMPANY;
const { COMPANY_STATUS_TITLE } = TEMPLATE.COMPANY;
const { reduxStoreWrapper } = REDUX_UTIL;

const TableCompany = (props) => {
  const {
    source,
    filteredData,
    paginatedData,
    tabKey,
    setFilteredData,
    selectedRow,
    setSelectedRow,
  } = props;

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tabStatus, setTabStatus] = useState({});
  const [isOpenRemark, setIsOpenRemark] = useState(false);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [isOpenThrshld, setIsOpenThrshld] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [data, setData] = useState({});

  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const loading = useSelector(reduxStoreWrapper("style.loading.company"));
  const user = useSelector(reduxStoreWrapper("user"));
  const company = useSelector(reduxStoreWrapper("company.byID"));

  const [originalData, setOriginalData] = useState([]);
  const [isData, setIsData] = useState(false);

  useEffect(() => {
    if (originalData?.length === 0 && !isData && filteredData[tabKey]?.length) {
      setOriginalData(filteredData[tabKey]);
      setIsData(true)
    }
  }, [filteredData, isData, tabKey]);

  const filterData = (data) =>
    filter.filterHDLR.tableData(
      data,
      filteredInfo,
      sortedInfo,
    );

  useEffect(() => {
    const filteredAndSortedData = filterData(source);

    if (tabStatus[tabKey] && filteredAndSortedData.length !== 0) {
      setFilteredData(filteredAndSortedData);
    }
  }, [tabKey, tabStatus[tabKey], sortedInfo, filteredInfo]);

  const handleTableChange = (_, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
    setTabStatus((prev) => ({
      ...prev,
      [tabKey]: true,
    }));
  };

  const handleSearch = (_, confirm) => {
    confirm();
  };

  const columns = [
    ...COMPANY_SUMMARY_COL({
      func: {
        handleSearch,
        handleRequestStatus,
        dispatch,
        messageApi,
        DrawerRemark: (data) => {
          setIsOpenRemark(true);
          setData(data);
        },
      },
      redux : { user, company }
    }),
    {
      title: "Actions",
      width: 100,
      fixed: "right",
      render: (_, record) => {
        return (
          <Dropdown
            menu={{
              items: ActionItems(
                record,
                setIsOpenEdit,
                setData,
                setIsOpenRemark,
                dispatch,
                messageApi,
                user
              ),
            }}
          >
            <ButtonLink>Actions</ButtonLink>
          </Dropdown>
        );
      },
    },
  ];

  const onSelectRow = (record, selected) => {
    tableHDLR.selectRow(
      setSelectedRowKeys,
      setSelectedRow,
      selectedRow,
      selectedRowKeys,
      record,
      selected
    );
  };

  const onSelectAllRows = (selected, selectedRows, changeRows) => {
    tableHDLR.selectAllRows(
      setSelectedRowKeys,
      setSelectedRow,
      selectedRow,
      selectedRowKeys,
      changeRows,
      selected,
    );
  };
  
  const rowSelection = {
    selectedRowKeys,
    onSelect: onSelectRow,
    onSelectAll: onSelectAllRows,
  };

  // const columns2 = EXPAND_COMPANY_SUMMARY_COL({ func: { handleSearch } });

  // const expandedRowRender = (record) => {
    // const { cardid } = record;

    // let loadTable = false;
    // if (Object.values(limits).length === 0 || !limits[cardid]) {
    //   dispatch(REDUX_ACTION.v1_card.get_cards_limit_request(cardid));
    //   loadTable = true;
    // }
    // return <Tabs items={ExpandTableItems(columns2)} />;
  // };

  return (
    <>
      {contextHolder}
      <DrawerRemark
        isOpen={isOpenRemark}
        setIsOpen={setIsOpenRemark}
        refid={data.coid}
        statusData={COMPANY_STATUS_TITLE}
        memid={data?.coid}
      />

      <EditCompanyDrawer
        isDrawerOpen={isOpenEdit}
        setIsDrawerOpen={setIsOpenEdit}
        data={data}
      />

      <ReviseCompanyThrshldDrawer
        isDrawerOpen={isOpenThrshld}
        setIsDrawerOpen={setIsOpenThrshld}
        data={data}
      />

      <TableList.DataList
        paginatedData={paginatedData}
        columnData={columns}
        rowSelection={rowSelection}
        onChange={handleTableChange}
        // expandedRowRender={expandedRowRender}
        loading={loading}
      />
    </>
  );
};

export default TableCompany;
